// inputSecurity.js

export const MALICIOUS_PATTERNS = [
  /[<>{}`]/, // Basic XSS characters
  /\b(on\w+)\s*=/i, // onclick=, onload=, onerror=, etc.
  /\b(SELECT|UPDATE|DELETE|DROP|INSERT|UNION|XP_)\b/i, // SQL keywords
  /(--|\bOR\b\s*1\s*=\s*1\b)/i, // Common SQL injection patterns
];

export const detectMaliciousInput = (value) => {
  if (!value || typeof value !== "string") return false;

  return MALICIOUS_PATTERNS.some((pattern) => pattern.test(value));
};

export const sanitizeInput = (value) => {
  if (!value || typeof value !== "string") return value;

  return value
    .trim()
    .replace(/[\r\n\t]+/g, " ")
    .replace(/[^\x20-\x7E]/g, "")
    .replace(/[<>"'`;(){}]/g, "");
};

export const validateSecureInput = (value) => {
  return !detectMaliciousInput(value);
};
